import { useAppSelector } from "../app/hooks";
import { selectLoggedInUser } from "../features/auth/auth.slice";
import { UserType } from "../shared/enums";
import MemberPaymentsBusinessView from "./member-payments-business-view";
import MemberPaymentsMemberView from "./member-payments-member-view";

const MemberPayments = () => {
    const loggedInUser = useAppSelector(selectLoggedInUser);

    return (
        <div>
            {loggedInUser?.type === UserType.BUSINESS_USER &&
                <MemberPaymentsBusinessView />

            }
            {loggedInUser?.type === UserType.MEMBER &&
                <MemberPaymentsMemberView />
            }
        </div>
    )
}

export default MemberPayments;